module.exports = __webpack_public_path__ + "img/building-video.fcb75961.jpg";